import { atom } from 'recoil';

export const detailEmailTicketAtom = atom({
    key: 'detailEmailTicketAtom',
    default: {
        open: false,
        ticketId: null
    }
});

export const openReplyDetailEmailAtom = atom({
    key: 'openReplyDetailEmailAtom',
    default: {
        open: false,
        ticketId: null,
        triggerData: {}
    }
});
